import { Component, Input, ViewChild, } from '@angular/core';
import { DataTableDynamicContentsDirective } from './dynamic/dynamic.contents.directive';
import * as i0 from "@angular/core";
import * as i1 from "./table.utils";
import * as i2 from "@angular/common";
import * as i3 from "./dynamic/dynamic.contents.directive";
function DataTableCellComponent_ng_container_0_ng_template_1_Template(rf, ctx) { }
function DataTableCellComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DataTableCellComponent_ng_container_0_ng_template_1_Template, 0, 0, "ng-template", 1);
    i0.ɵɵelementContainerEnd();
} }
function DataTableCellComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.noComponentContents, " ");
} }
export class DataTableCellComponent {
    constructor(tableUtils, componentFactoryResolver, cdr) {
        this.tableUtils = tableUtils;
        this.componentFactoryResolver = componentFactoryResolver;
        this.cdr = cdr;
    }
    ngAfterViewInit() {
        this.loadComponent();
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    retrieveCell(row, column) {
        return this.tableUtils.retrieveCell(row, column);
    }
    loadComponent() {
        if (this.column.component) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            const contents = this.retrieveCell(this.row, this.column);
            // const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.column.component);
            const viewContainerRef = this.tableCellContentsDirective.viewContainerRef;
            viewContainerRef.clear();
            const componentRef = viewContainerRef.createComponent(this.column.component);
            componentRef.instance.data = contents;
            componentRef.instance.row = this.row;
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            this.noComponentContents = this.retrieveCell(this.row, this.column);
        }
        // without this, everything went boom
        this.cdr.detectChanges();
    }
}
DataTableCellComponent.ɵfac = function DataTableCellComponent_Factory(t) { return new (t || DataTableCellComponent)(i0.ɵɵdirectiveInject(i1.DataTableUtils), i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
DataTableCellComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DataTableCellComponent, selectors: [["DataTable-cell"]], viewQuery: function DataTableCellComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(DataTableDynamicContentsDirective, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tableCellContentsDirective = _t.first);
    } }, inputs: { column: "column", row: "row" }, decls: 2, vars: 2, consts: [[4, "ngIf"], ["DataTableDynamicContents", ""]], template: function DataTableCellComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, DataTableCellComponent_ng_container_0_Template, 2, 0, "ng-container", 0);
        i0.ɵɵtemplate(1, DataTableCellComponent_ng_container_1_Template, 2, 1, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.column.component);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.noComponentContents !== null && ctx.noComponentContents !== undefined);
    } }, dependencies: [i2.NgIf, i3.DataTableDynamicContentsDirective], styles: ["\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataTableCellComponent, [{
        type: Component,
        args: [{ selector: 'DataTable-cell', template: `
    <ng-container *ngIf="column.component">
      <ng-template DataTableDynamicContents></ng-template>
    </ng-container>
    <ng-container *ngIf="noComponentContents !== null && noComponentContents !== undefined">
      {{ noComponentContents }}
    </ng-container>
  `, styles: ["/*# sourceMappingURL=table.component.css.map */\n"] }]
    }], function () { return [{ type: i1.DataTableUtils }, { type: i0.ComponentFactoryResolver }, { type: i0.ChangeDetectorRef }]; }, { column: [{
            type: Input
        }], row: [{
            type: Input
        }], tableCellContentsDirective: [{
            type: ViewChild,
            args: [DataTableDynamicContentsDirective]
        }] }); })();
